// src/utils/signatureUtils.js
// Lógica condicional de firma según país de diagnóstico

/**
 * getAuthorSignature
 * Devuelve la firma correcta según el país donde se tomó la foto.
 *
 * Regla:
 *   país = MX  → "Arq. Eugenio Carrasco · Vicepresidente, ICRI México"
 *   país ≠ MX  → "Arq. Eugenio Carrasco"
 *   no determinable → sin cargo institucional
 *
 * @param {string|null} countryCode - ISO 3166-1 alpha-2 (e.g. 'MX', 'US')
 * @returns {{ name: string, title: string|null, org: string|null }}
 */
export function getAuthorSignature(countryCode = null) {
  const isMexico = countryCode?.toUpperCase() === 'MX';

  return {
    name:  'Arq. Eugenio Carrasco',
    title: isMexico ? 'Vicepresidente, ICRI México' : null,
    org:   isMexico ? 'Consultor Técnico Sr., Sika México' : null,
  };
}

/**
 * formatSignatureLines
 * Devuelve un array de líneas para renderizar en UI y PDF.
 *
 * @param {ReturnType<getAuthorSignature>} sig
 * @returns {string[]}
 */
export function formatSignatureLines(sig) {
  const lines = [sig.name];
  if (sig.title) lines.push(sig.title);
  if (sig.org)   lines.push(sig.org);
  return lines;
}
